import {setGetPresentListAction} from '../action';
import { getPresentList } from '../api/getPresentList';

const setGetPresentList = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getPresentList(params);
    
            if (data.status === 'success') {
                dispatch(setGetPresentListAction({
                    list: data.data,
                    page: data.countPage
                }));
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetPresentList
}